export default {
  loadAPI() {
    let id = "twitter-wjs";

    // if script was already set, don't load it again.

    var s = document.createElement("script");
    s.id = id;
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://platform.twitter.com/widgets.js";
    document.getElementsByTagName("head")[0].appendChild(s);
  },
  unloadAPI() {
    let id = "twitter-wjs";

    // if script was already set, don't load it again.
    let twit = document.getElementById(id);
    if (twit) {
      twit.remove();
    }
  },
};
